(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gibbon-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.GibbonGallery) return;
    // Event delegation throughout, so galleries swapped in later (the SlackBoard design switch) work without setup.
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function slidesOf(g) { return g.querySelectorAll('[data-ggal-slide]'); }
    function trackOf(g) { return g.querySelector('[data-ggal-track]'); }
    function current(g) { var t = trackOf(g); return t ? Math.round(t.scrollLeft / Math.max(t.clientWidth, 1)) : 0; }
    function paint(g, i) {
      if (+g.dataset.ggalIndex === i) return;
      g.dataset.ggalIndex = i;
      g.querySelectorAll('.ggal__dots span').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var thumbs = g.querySelectorAll('[data-ggal-thumb]');
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      slidesOf(g).forEach(function (s, k) { var v = s.querySelector('video'); if (v && k !== i) v.pause(); });
    }
    // While a thumbnail or arrow scrolls the track, the photos it passes are not painted as current.
    var targets = new WeakMap();
    function go(g, i, instant) {
      var t = trackOf(g), n = slidesOf(g).length;
      if (!t || !n) return;
      i = (i + n) % n;
      targets.set(g, { index: i, until: Date.now() + 1500 });
      t.scrollTo({ left: t.clientWidth * i, behavior: instant || reduce.matches ? 'auto' : 'smooth' });
      paint(g, i);
    }
    function settled(g) {
      var aim = targets.get(g);
      if (!aim) return true;
      if (current(g) === aim.index || Date.now() > aim.until) { targets.delete(g); return true; }
      return false;
    }
    function base(g) { var aim = targets.get(g); return aim ? aim.index : current(g); }

    var frames = new WeakMap();
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.matches('[data-ggal-track]')) return;
      cancelAnimationFrame(frames.get(t));
      frames.set(t, requestAnimationFrame(function () { var g = t.closest('[data-ggal]'); if (g && settled(g)) paint(g, current(g)); }));
    }, true);

    // Zoom: one shared dialog, stepping through the photos of the gallery it was opened from.
    var zoom, zoomList = [], zoomAt = 0;
    function icon(d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    function showZoom(i) {
      zoomAt = (i + zoomList.length) % zoomList.length;
      var img = zoom.querySelector('.ggal-zoom__img');
      img.src = zoomList[zoomAt].src;
      img.alt = zoomList[zoomAt].alt;
      zoom.querySelector('.ggal-zoom__count').textContent = (zoomAt + 1) + ' / ' + zoomList.length;
      zoom.querySelectorAll('.ggal-zoom__prev, .ggal-zoom__next, .ggal-zoom__count').forEach(function (b) { b.hidden = zoomList.length < 2; });
    }
    function openZoom(g, slide) {
      if (!zoom) {
        zoom = document.createElement('dialog');
        zoom.className = 'ggal-zoom';
        zoom.setAttribute('aria-label', 'Photo viewer');
        zoom.innerHTML = '<img class="ggal-zoom__img" alt="">'
          + '<button type="button" class="ggal-zoom__btn ggal-zoom__close" aria-label="Close">' + icon('M6 6l12 12M18 6L6 18') + '</button>'
          + '<button type="button" class="ggal-zoom__btn ggal-zoom__prev" aria-label="Previous photo">' + icon('M15 5l-7 7 7 7') + '</button>'
          + '<button type="button" class="ggal-zoom__btn ggal-zoom__next" aria-label="Next photo">' + icon('M9 5l7 7-7 7') + '</button>'
          + '<span class="ggal-zoom__count"></span>';
        document.body.appendChild(zoom);
        zoom.addEventListener('click', function (e) {
          if (e.target.closest('.ggal-zoom__prev')) showZoom(zoomAt - 1);
          else if (e.target.closest('.ggal-zoom__next')) showZoom(zoomAt + 1);
          else zoom.close();
        });
        zoom.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') showZoom(zoomAt - 1);
          if (e.key === 'ArrowRight') showZoom(zoomAt + 1);
        });
      }
      var start = 0;
      zoomList = [];
      g.querySelectorAll('[data-ggal-slide][data-zoom]').forEach(function (s) {
        if (s === slide) start = zoomList.length;
        var im = s.querySelector('img');
        zoomList.push({ src: s.dataset.zoom, alt: im ? im.alt : '' });
      });
      if (!zoomList.length) return;
      showZoom(start);
      if (zoom.showModal) zoom.showModal(); else zoom.setAttribute('open', '');
    }

    document.addEventListener('click', function (e) {
      var g = e.target.closest('[data-ggal]');
      if (!g) return;
      var thumb = e.target.closest('[data-ggal-thumb]');
      if (thumb) { e.preventDefault(); go(g, Array.prototype.indexOf.call(g.querySelectorAll('[data-ggal-thumb]'), thumb)); return; }
      var step = e.target.closest('[data-ggal-step]');
      if (step) { e.preventDefault(); go(g, base(g) + (+step.dataset.ggalStep)); return; }
      var slide = e.target.closest('[data-ggal-slide][data-zoom]');
      if (slide && e.target.tagName === 'IMG') openZoom(g, slide);
    });
    document.addEventListener('keydown', function (e) {
      if (!e.target.matches || !e.target.matches('[data-ggal-track]')) return;
      var g = e.target.closest('[data-ggal]');
      if (e.key === 'ArrowRight') { e.preventDefault(); go(g, base(g) + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(g, base(g) - 1); }
    });

    // Choosing a variant shows its photo (the theme announces it on the product section).
    document.addEventListener('variantImageChange', function (e) {
      var v = e.detail && e.detail.variant, id = v && v.featured_media && v.featured_media.id;
      if (!id || !e.target.querySelectorAll) return;
      e.target.querySelectorAll('[data-ggal]').forEach(function (g) {
        var i = Array.prototype.findIndex.call(slidesOf(g), function (s) { return s.dataset.mediaId === String(id); });
        if (i > -1) go(g, i);
      });
    }, true);

    // Keep the current photo lined up when the width changes, and open on the variant's photo for ?variant= links.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { document.querySelectorAll('[data-ggal]').forEach(function (g) { go(g, +g.dataset.ggalIndex || 0, true); }); }, 150);
    });
    function start() { document.querySelectorAll('[data-ggal][data-ggal-start]').forEach(function (g) { go(g, +g.dataset.ggalStart, true); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.GibbonGallery = { go: go };
  })();
  } catch(e) { console.error(e); }
})();

})();
